import { TimeSlotConfigurationsDataType } from '@modules/timetable/types/manageTimetable';

export const timelineKeys = {
  groupIdKey: 'id',
  groupTitleKey: 'title',
  groupRightTitleKey: 'rightTitle',
  itemIdKey: 'id',
  itemTitleKey: 'title', // key for item div content
  itemDivTitleKey: 'title', // key for item div title (<div title="text"/>)
  itemGroupKey: 'groupID',
  itemTimeStartKey: 'startTime',
  itemTimeEndKey: 'endTime',
};

export const initialTimeSlotConfigurationValues: TimeSlotConfigurationsDataType = {
  monday: [],
  tuesday: [],
  wednesday: [],
  thursday: [],
  friday: [],
  saturday: [],
  sunday: [],
};

export const academicCalendarItemBackgroundColors = {
  academic: '#f7931c',
  holiday: '#d8ffeb',
};
